import {Timer} from '@gongxigames/framework/core';
import {AutoplayView} from '@gongxigames/framework/slot/modules/autoplay/AutoplayView';
import {AutoplayModule} from '@gongxigames/framework/slot/modules/autoplay/AutoplayModule';
import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay/AutoplayEvents';
import {RealityCheckEvents} from '@gongxigames/framework/slot/modules/realitycheck/RealityCheckEvents';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

// @ts-ignore
export class AutoplayReadyForSpinState extends ModuleState<AutoplayView, AutoplayModule, GlobalEventsMapForBackwardCompatibility> {

    public static readonly TIME_BEFORE_NEXT_SPIN: number = 500;
    protected timer?: Timer;

    public onEnterState(): void {
        // we should start spin immediately after autoplay button was pressed
        // in other case spin must be started in 0.5 sec
        if (this.module.isAutoplayJustStarted) {
            this.module.isAutoplayJustStarted = false;
            this.startAutoplaySpin();
        } else {
            if (this.module.isDelayBeforeSpin) {
                this.timer = this.module.updateManager.addTimer(this.processAutoplay.bind(this), AutoplayReadyForSpinState.TIME_BEFORE_NEXT_SPIN, true);
            } else {
                this.processAutoplay();
            }
        }
    }

    public onLeaveState(): void {
        if (this.timer && this.timer.isPlaying) {
            this.timer.stop();
        }
    }

    protected setupEvents(): void {
        this.setEventHandler(AutoplayView.STOP_AUTOPLAY_BUTTON_CLICKED, this.goToBasicState.bind(this));
        this.setEventHandler(RealityCheckEvents.SHOWED, this.goToBasicState.bind(this));
        this.setEventHandler(LogicEvents.REALITY_CHECK, this.goToBasicState.bind(this));
        this.setEventHandler('Autoplay.STOP', this.goToBasicState.bind(this));
    }

    protected goToBasicState(): void {
        this.module.gotoState(AutoplayModule.BASIC_STATE);
    }

    protected startAutoplaySpin(): void {
        if (this.module.logic.nextAction === Action.RESPIN) {
            this.module.gotoState(AutoplayModule.WAITING_FOR_READY_STATE);

            return;
        }

        this.checkState();

        this.module.decreaseSpins();
        this.module.updateSpinsView();
        this.module.eventManager.emit(AutoplayEvents.AUTOPLAY_START_SPIN);
        this.module.eventManager.emit('Autoplay.START_SPIN');
        this.module.gotoState(AutoplayModule.WAITING_FOR_READY_STATE);
    }

    protected processAutoplay(): void {
        if (this.module.shouldAutoplayStopAndShowMessage()) {
            this.module.setSpins(0);
            this.goToBasicState();

            return;
        }

        this.startAutoplaySpin();
    }

    protected checkState(): void {
        if (!this.module.isAutoplayEnabled) {
            throw new Error('Something went wrong in AutoplayReadyForSpinState. ' +
                'Can\'t be here while autoplay is disabled');
        }
    }
}
